// extracted by mini-css-extract-plugin
export default {"root":"IconMotorcycle_root__NZBuA"};